import { notifications, companies } from '@/endpoint.flexigo';
import Repository from './repository';

const client = new Repository();

export default {
  async getNotifications(payload) {
    const r = await client.get(notifications.notifications, payload);
    return r;
  },
  async getNotificationDetails(id) {
    const r = await client.get(notifications.getNotifications.replace(':id', id));
    return r;
  },

  async getRoutes(workgroupType = null, campusId = null) {
    const params = {};
    if (workgroupType) params.workgroupType = workgroupType;
    if (campusId) params.campusId = campusId;
    const r = await client.get(notifications.routes, params);
    return r;
  },

  async getShuttleProviders() {
    const r = await client.get(`${companies.serviceProviders}?lightMode=true`);
    return r;
  },
  async sendPersonnelNotification(payload) {
    const formData = new FormData();
    formData.append('message', payload.message || null);
    formData.append('title', payload.title || null);
    formData.append('personnelIds', payload.personnelIds || null);
    if (payload.notificationDateTime) formData.append('notificationDateTime', payload.notificationDateTime);
    formData.append('file', payload.file || null);
    const r = await client.post(notifications.personnelNotifications, formData);
    return r;
  },
  async sendNotification(payload) {
    const formData = new FormData();
    if (payload.routeIds && payload.routeIds.length > 0) {
      formData.append('routeIds', payload.routeIds);
    }
    if (payload.destinationId) {
      formData.append('destinationId', payload.destinationId);
    }
    if (payload.shuttleProviderId) {
      formData.append('shuttleProviderId', payload.shuttleProviderId);
    }
    if (payload.serviceType) {
      formData.append('serviceType', payload.serviceType);
    }
    if (payload.sendTime) {
      formData.append('notificationDateTime', payload.sendTime);
    }
    if (payload.isAnnouncement) {
      formData.append('isAnnouncement', payload.isAnnouncement);
    }
    if (payload.announceUntil) {
      formData.append('announceUntil', payload.announceUntil);
    }

    formData.append('notifyPassivePersonnel', payload.notifyPassivePersonnel);
    formData.append('title', payload.title);
    formData.append('message', payload.message);
    if (payload.file) {
      formData.append('file', payload.file);
    }

    const r = await client.post(notifications.createNotifications, formData);
    return r;
  },
  async getOwnCampuses() {
    const r = await client.get(notifications.ownCampuses);
    return r;
  },
  async cancelNotification(id) {
    const r = await client.post(notifications.cancelNotification.replace(':id', id));
    return r;
  },
  async updateNotification(payload) {
    const { id, ...data } = payload;
    const r = await client.post(notifications.updateNotification.replace(':id', id), data);
    return r;
  },
};
